export default "__VITE_ASSET__CcLkfAhs__"